import React, { useEffect, useRef, useState } from "react";

interface SSRLottieProps {
  animationData: any;
  loop?: boolean;
  autoplay?: boolean;
  style?: React.CSSProperties;
}

const SSRLottie = ({ animationData, loop = true, autoplay = true, style }: SSRLottieProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [lottie, setLottie] = useState<any>(null);

  const isClient = typeof window !== "undefined";

  useEffect(() => {
    if (!isClient) return;
    (async () => {
      try {
        const mod = await import("lottie-web");
        setLottie(mod.default ?? mod);
      } catch (err) {
        //console.error("Failed to load lottie-web:", err);
      }
    })();
  }, [isClient]);

  useEffect(() => {
    if (!lottie || !containerRef.current) return;

    // 애니메이션 로드
    const anim = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop,
      autoplay,
      animationData,
    });

    // 언마운트 시 해제
    return () => {
      anim.destroy();
    };
  }, [lottie, loop, autoplay, animationData]);

  if (!isClient) return null;
  return <div ref={containerRef} style={style} />;
};

export default SSRLottie;
